import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
import { Ship, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const isRTL = language === 'ar';

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#002a40] to-[#003d5c] text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/cozey-logo.jpg" 
                alt="Cozey Yildiz Export L.L.C" 
                className="h-20 w-auto object-contain"
              />
            </div>
            <h3 className="text-xl font-bold mb-3">{t.footer.company}</h3>
            <p className="text-blue-200 leading-relaxed max-w-md">
              {t.footer.description}
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t.footer.services}</h4>
            <ul className="space-y-2 text-blue-200">
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors">
                  {language === 'en' ? 'Ocean Freight' : 'الشحن البحري'}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors">
                  {language === 'en' ? 'China Sourcing' : 'التوريد من الصين'}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors">
                  {language === 'en' ? 'Customs Clearance' : 'التخليص الجمركي'}
                </button>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2 text-blue-200">
              <li>
                <button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors">
                  {t.nav.about}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="hover:text-white transition-colors">
                  {t.nav.gallery}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-white transition-colors">
                  {t.nav.contact}
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Contact Info Bar */}
        <div className="border-t border-blue-400/30 pt-8 mb-8">
          <div className="grid md:grid-cols-3 gap-6 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start space-x-3">
              <MapPin className="h-5 w-5 text-blue-300" />
              <span className="text-blue-200">{language === 'en' ? 'Latakia, Syria' : 'اللاذقية، سوريا'}</span>
            </div>
            <div className="flex items-center justify-center md:justify-start space-x-3">
              <Phone className="h-5 w-5 text-blue-300" />
              <a href="tel:+905346635111" className="text-blue-200 hover:text-white transition-colors">
                +90 534 663 51 11
              </a>
            </div>
            <div className="flex items-center justify-center md:justify-start space-x-3">
              <Mail className="h-5 w-5 text-blue-300" />
              <a href="mailto:info@cozeyyildiz.com" className="text-blue-200 hover:text-white transition-colors">
                info@cozeyyildiz.com
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-blue-400/30 pt-8 text-center text-blue-200">
          <p>
            &copy; {new Date().getFullYear()} {t.footer.company}. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;